<body>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div class="unsubscribe_block">
                    <div class="image">
                        <img class="top-logo" src="../../../../assets/images/new-logo-cropped.svg" alt="logo"/>
                    </div>
                    <div class="content">
                        <h4>{{ "SUCCESSFULLY_UNSUBSCRIBED" | translate }}</h4>
                        <p class="msg-text">
                            {{ "PLEASE_HELP_US_TO_UNDERSTAND_REASON" | translate }}
                        </p>
                        <div *ngFor="let value of emailsReason">
                            <ul>
                                <li>
                                    <input type="radio" name="options" [(ngModel)]="selectedValue"
                                        [value]="value" />
                                    <span>{{ value }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="text-area-action">
                            <textarea id="textarea" [(ngModel)]="reasonString"
                                *ngIf="selectedValue === emailsReason[emailsReason.length - 1]" rows="3"
                                cols="60"></textarea>
                            </div>
                        </div>
                        <div class="action-btn my-3">
                            <button class="btn btn-primary" (click)="submit()">
                                {{ "SUBMIT" | translate }}
                            </button>
                        </div>
                </div>
            </div>
        </div>
        <div class="bg">
            <div class="unsubscribe-box">
                <p><strong class="success-text"></strong></p>
            </div>
        </div>
    </div>
</body>